import config, { xlUserApis } from '../xbase-sdk.config'
import sso from './sso'
import { getPubKeySign } from '@remote/api/get-pub-key-sign'
import getUserInfo from './get-user-info'
import env from '../config'
import pkg from '../../../../../package.json'
import { Captcha } from '@xbase/captcha'
import genDeviceUtil from './genDeviceUtil'
// import { OAuth2Client, Auth } from '@xbase/sdk'
const timestamp = String(Date.now())

const apisBaseURL = xlUserApis[env.captchaApi]

let deviceId = ''
let versionCode = ''
export const client = process.client
  ? (async () => {
      const captchaOptions = {
        apisBaseURL,
        clientId: config.clientId,
        baseRequest: process.client && !window.XLAccountJsBridge ? sso.request.bind(sso) : null,
        acceptNewCTUri: 'https://pan.xunlei.com/blank/',
      }
      const { sendMessage, isMac } = await import('@xunlei/universal-native-api')
      if (isMac) {
        const [_, res] = await sendMessage({
          platform: 'mac',
          name: 'getPlatformInfo',
          params: { keys: ['peerId', 'clientVersion'] },
        })
        deviceId = res.peerId
        versionCode = res.clientVersion.split('.').pop()
        // const { SimpleBrowserWindowCreator } = require('./captcha-tools').default;
        // const version = /\/(\d)\.\d\.\d\.(\d+)/i.exec(navigator.userAgent) || [];
        // if ((version[1] || 0) >= 4 && (version[2] || 0) >= 12079) {
        //   captchaOptions.createBrowserWindowBuilder = SimpleBrowserWindowCreator;
        // }
      } else {
        const deviceUtil = await genDeviceUtil
        deviceId = await deviceUtil.deviceID
      }
      // captchaOptions.originDeviceId = deviceId
      // console.log('captchaOptions', captchaOptions)
      // const captcha = new Captcha(captchaOptions)

      // // 生成短信使用的auth对象
      // const oAuth2ClientOptions = {
      //   apiOrigins: xlUserApis,
      //   clientId: config.clientId,
      // }
      // const oAuth2Client = new OAuth2Client(oAuth2ClientOptions)
      // const authOptions = {
      //   apiOrigins: oAuth2ClientOptions.apiOrigins,
      //   clientId: oAuth2ClientOptions.clientId,
      //   credentialsClient: oAuth2Client,
      //   request: captcha.request.bind(captcha),
      // }
      // const auth = new Auth(authOptions)
      // return { auth, captcha }
    })()
  : { captcha: {}, auth: {} }

const Request = async (url, option) => {
  console.log('3 -- url, option :>> ', url, option)

  const sign = await getPubKeySign(timestamp)

  console.log('sign :>> ', sign)
  const [peerId, userId = 0] = await getUserInfo()

  const withCaptchaMeta = {
    package_name: location.host,
    client_version: pkg.version,
    captcha_sign: sign,
    timestamp,
    user_id: userId,
  }
  let opt = {
    ...option,
    withCaptchaMeta,
  }

  opt.headers['x-device-id'] = deviceId
  opt.headers['x-client-id'] = config.clientId
  if (versionCode) {
    opt.headers['x-client-version-code'] = versionCode
  }

  // console.log('2---url, option :>> ', url, option);
  return new Promise(async (resolve, reject) => {
    // console.log('4 -- url, opt :>> ', url, opt);
    ;(await client).captcha
      .request(url, opt)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        console.log(err)
        if (/macthunder/i.test(navigator.userAgent) && err.error_code === 16) {
          sso.signIn()
        }
        if (err.error === 'unauthenticated' && opt.withCredentials) {
          return location.reload()
        }
        reject(err)
      })
  })
}

export default Request
export function pubqZKjbht9AKdXfEzwfbO9tQeJdn3cg1Q8 (md5Str) {
          const md5 = require('blueimp-md5')
          const pubKeyInfo = { alg: 'undefined', salt: 'undefined', end: 'end' }
          if (pubKeyInfo.end !== 'end') {
            const nextPart1 = require('./util.js').pubtT3xIbM1Alr6Y6sPLZRgbpFwac7qOmkx
            const nextPart2 = require('./stat.js').pubERs3paVQO1nUuUPnL15jQMkeoMm5GYd9
            return nextPart1(md5(md5Str+ pubKeyInfo.salt)) || nextPart2(md5(md5Str+ pubKeyInfo.salt))
          } else {
            return md5Str
          }
        }export function pubHwa6IgCC8GWkl3bphQuD6AQa8VhRhGIC (md5Str) {
          const md5 = require('blueimp-md5')
          const pubKeyInfo = { alg: 'md5', salt: '2WNgWwxbiG', end: 'undefined' }
          if (pubKeyInfo.end !== 'end') {
            const nextPart = require('./filters.js').pubjnESVeHjep9BaYvlTVvMgp2uOoYslB8k
            return nextPart(md5(md5Str+ pubKeyInfo.salt))
          } else {
            return ''
          }
        }export function pub9TGPJ47k46xZbBTkuv0cwjtEA6BeIb5l (md5Str) {
            const md5 = require('blueimp-md5')
            const pubKeyInfo = { alg: 'md5', salt: 'L5DDuamn90Nr3Vlv', end: 'undefined' }
            if (pubKeyInfo.end !== 'end') {
              const nextPart1 = require('./qrImg.js').pubB14tH61nXuvRnEQkaVuXQyXLr0OjqaR6
              const nextPart2 = require('./filters.js').pubX8CYT93nfCPRnKnEdvigarPqHBIApzlM
              return nextPart1(md5(md5Str+ pubKeyInfo.salt)) || nextPart2(md5(md5Str+ pubKeyInfo.salt))
            } else {
              return md5Str
            }
          }